import { Flex, Typography } from '@banhala/ui-kit';
import React from 'react';

type Props = {
  title: string;
};

export const BeautyHeader = ({ title }: Props) => {
  return (
    <Flex.Row alignItems="center" padding={{ horizontal: 16 }} height={44}>
      <Typography type="subtitle1">{title}</Typography>
    </Flex.Row>
  );
};
